import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireCompleteProfile } from "@/lib/auth-guard";
// TODO: Re-enable when article navigation is needed
// import ArticleNavbar from "@/components/application/articles/ArticleNavbar";

const ArticlesLayoutPage = () => {
  return (
    <div>
      {/* {!isQuizResults && <ArticleNavbar />} */}
      <Outlet />
    </div>
  );
};

export const Route = createFileRoute("/articles")({
  ...requireCompleteProfile(),
  component: ArticlesLayoutPage,
});
